import { Component } from '@angular/core';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { VisitResult } from 'src/app/assabil-kernel/models/entities/control-tables/visit-result';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { VisitResultRequest } from 'src/app/assabil-kernel/models/dtos/control-tables/visit-result-request';



@Component({
  selector: 'app-visit-result-list',
  templateUrl: './visit-result-list.component.html',
  styleUrls: ['./visit-result-list.component.scss']
})

export class VisitResultListComponent extends BasePage2<VisitResult> {

  // Filter fields
  // ---------------------------------------------------
  code: string;
  name: string;
  // ---------------------------------------------------
      
  // ---------------------------------------------------
  visitResults: VisitResult[] = [];
  // ---------------------------------------------------
  

  constructor(
      protected toastr            : ToastrService,
      protected controlService    : ControlTablesService,
      protected router            : Router,
      protected baseService       : BaseService,
      protected leanUtilsService  : LeanUtilsService,
      protected location          : Location) {
      super(toastr, router, baseService, leanUtilsService, location);

      this.entityName = 'visitResult';
  }


  listFields = [
      { prop: 'visitResultCode',    name: 'Code',  insertOnly : true  },
      { prop: 'name',               name: 'Name'                      },
      { prop: 'rank',               name: 'Rang',   type : 'number'   },
      { prop: 'revisit',            name: 'Revisit',type : 'boolean'  },
  ]

  
//----------------------------------------------------------------------
getRows(): VisitResult[] {
    return this.visitResults;
}
//----------------------------------------------------------------------

//----------------------------------------------------------------------
saveRow(visitResult: VisitResult): Promise<VisitResult> {
  let request  : VisitResultRequest = new VisitResultRequest(this.controlService.getUserInfo());
  request.visitResult = visitResult;
    return this.controlService.save(this.entityName, request);
}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
new(){
  let entity : VisitResult = new VisitResult();
  entity.inserted = true;
  entity.edit = true;
  this.visitResults.push(entity);
  this.visitResults = [...this.visitResults];
}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
loadData() {
  let request         : BaseRequest = this.controlService.getRequest();
  request.strArg1 = this.code;
  request.strArg2 = this.name;

  this.controlService.getList(this.entityName, request).then(result => {
      this.visitResults = result;
      
  }).catch(error => {
      this.showError(error);
  })
}
//----------------------------------------------------------------------


}
